import { gql, useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";

const REJECT_PRODUCTION_PLAN = gql`
  mutation ($planId: ID!) {
    rejectProductionPlan(planId: $planId) {
      productionPlan {
        id
        state
        startDate
        salesConfirmAt
        customerConfirmAt
        confirmTimeAt
        confirmCostAt
        readyDate
      }
    }
  }
`;

const RejectPlanView = ({ onCompleted, plan }) => {
  const [rejectPlan, rejectPlanRes] = useMutation(REJECT_PRODUCTION_PLAN, {
    onCompleted(res) {
      Alert("success", "Updated.");
      if (onCompleted) onCompleted(res);
    },
    onError(error) {
      Alert("error", error.message);
    },
    refetchQueries: ["FETCH_PREV_PLANS"],
  });

  return (
    <div className="text-sm">
      <div className="space-y-2">
        <p>Are you sure to reject this plan? </p>
        <p>
          Rejecting a plan will release the stock and production time, this plan
          will be set to DRAFT state. If there are plans after this plan, they
          will be recomputed.
        </p>
      </div>

      <hr />

      <div className="flex space-x-6">
        <Button
          className="text-lg"
          danger
          loading={rejectPlanRes.loading}
          onClick={() =>
            rejectPlan({
              variables: {
                planId: plan.id,
                cancelLaterPlans: false,
              },
            })
          }
        >
          Confirm Reject
        </Button>
      </div>
    </div>
  );
};

export default RejectPlanView;
